/**
 * Lucent Sky ESG - Business Configuration
 * Central location for all business identity and branding information
 * This file allows easy updates without modifying multiple files
 */

export const BUSINESS_CONFIG = {
  // Brand Identity
  name: 'Lucent Sky ESG',
  tagline: "Australia's Climate-Fintech Platform",
  slogan: 'Clear Skies, Greener Bottom Lines',
  
  // Legal Entity
  abn: '37 351 283 491',
  abnFormatted: 'ABN: 37 351 283 491',
  legalName: 'Lucent Sky ESG Pty Ltd',
  
  // Contact
  supportEmail: 'hello@lucentsky.com.au',
  domain: 'lucentsky.com.au',
  
  // Address (editable from Admin Portal)
  address: {
    street: '64 Meadow Court',
    suburb: 'Doonan',
    state: 'QLD',
    postcode: '4562',
    country: 'Australia'
  },
  
  // Formatted address helpers
  get fullAddress() {
    return `${this.address.street}, ${this.address.suburb}, ${this.address.state}, ${this.address.postcode}`;
  },
  
  get shortAddress() {
    return `${this.address.suburb}, ${this.address.state}`;
  },
  
  // Theme Colors (for reference)
  colors: {
    navy: '#003B5C',
    green: '#74A57F',
    slate: '#64748B'
  },
  
  // URLs
  previewUrl: 'https://lucentsky.com.au',
  
  // Compliance
  ngaYear: 2026,
  complianceFramework: 'AASB S2'
};

export default BUSINESS_CONFIG;
